export type authSteps =
  | "EMAIL_ADD"
  | "EMAIL_CONFIRM"
  | "EMAIL_VERIFY"
  | "EMAIL_VERIFY_NEW"
  | "MFA_ADD"
  | "MFA_CONFIRM"
  | "MFA_RESET"
  | "MFA_VERIFY"
  | "OTP_RESEND"
  | "PASSWORD_CONFIRM"
  | "PASSWORD_NEW_VERIFY"
  | "PHONE_ADD"
  | "PHONE_CONFIRM"
  | "PHONE_VERIFY"
  | "PHONE_VERIFY_NEW";

export type authStepUpScopes =
  | "STEP_UP_WITHDRAWAL"
  | "STEP_UP_TRANSFER"
  | "STEP_UP_CLAIM"
  | "STEP_UP_CARD";

export interface StepPayloads {
  // if from telegram want to add new email (not link)
  EMAIL_ADD: { email: string };
  // if from telegram want to add new email (not link)
  EMAIL_CONFIRM: { code: string };
  EMAIL_VERIFY: { code: string };
  EMAIL_VERIFY_NEW: { code: string };
  //on mfasetup
  MFA_ADD: undefined;
  MFA_CONFIRM: { totp: string };
  //on mfaremove
  MFA_RESET: undefined;
  MFA_VERIFY: { totp: string };
  OTP_RESEND: undefined;
  PASSWORD_CONFIRM: undefined;
  // auto new pass verify call
  PASSWORD_NEW_VERIFY: undefined;
  PHONE_ADD: { phone: string };
  //phone code is sms
  PHONE_CONFIRM: { code: string };
  PHONE_VERIFY: { code: string };
  PHONE_VERIFY_NEW: { code: string };
}

export type StepConfig<TPayload> = {
  url: string;
  title: string;
  payload?: TPayload;
  inputField?: TPayload extends object ? keyof TPayload : undefined;
  inputLabel?: TPayload extends object ? string : undefined;
};

export const stepperConfig: { [K in authSteps]: StepConfig<StepPayloads[K]> } =
  {
    EMAIL_ADD: {
      url: "email/add",
      title: "EMAIL_ADD",
      payload: { email: "" },
      inputField: "email",
      inputLabel: "ENTER_EMAIL",
    },
    EMAIL_CONFIRM: {
      url: "email/confirm",
      title: "ENTER_CODE_FROM_EMAIL",
      payload: { code: "" },
      inputField: "code",
      inputLabel: "ENTER_CONFIRMATION_CODE",
    },
    EMAIL_VERIFY: {
      url: "email/verify",
      title: "ENTER_CODE_FROM_EMAIL",
      payload: { code: "" },
      inputField: "code",
      inputLabel: "ENTER_VERIFICATION_CODE",
    },
    EMAIL_VERIFY_NEW: {
      url: "email/verify/new",
      title: "ENTER_CODE_FROM_EMAIL",
      payload: { code: "" },
      inputField: "code",
      inputLabel: "ENTER_VERIFICATION_CODE",
    },
    MFA_ADD: { url: "mfa/add", title: "MFA_ADD" },
    MFA_CONFIRM: {
      url: "mfa/confirm",
      title: "ENDER_CODE_FROM_AUTHENTICATOR",
      payload: { totp: "" },
      inputField: "totp",
      inputLabel: "ENTER_MFA_CODE",
    },
    MFA_RESET: { url: "mfa/reset", title: "MFA_RESET" },
    MFA_VERIFY: {
      url: "mfa/verify",
      title: "ENDER_CODE_FROM_AUTHENTICATOR",
      payload: { totp: "" },
      inputField: "totp",
      inputLabel: "ENTER_MFA_VERIFICATION_CODE",
    },
    OTP_RESEND: { url: "otp/resend", title: "OTP_RESEND" },
    PASSWORD_CONFIRM: { url: "password/confirm", title: "ENTER_YOUR_PASSWORD" },
    PASSWORD_NEW_VERIFY: {
      url: "password/verify/new",
      title: "ENTER_AGAIN_PASSWORD",
    },
    PHONE_ADD: {
      url: "phone/add",
      title: "PHONE_ADD",
      payload: { phone: "" },
      inputField: "phone",
      inputLabel: "ENTER_PHONE_NUMBER",
    },
    PHONE_CONFIRM: {
      url: "phone/confirm",
      title: "PHONE_CONFIRM",
      payload: { code: "" },
      inputField: "code",
      inputLabel: "ENTER_PHONE_CONFIRMATION_CODE",
    },
    PHONE_VERIFY: { url: "phone/verify", title: "PHONE_VERIFY" },
    PHONE_VERIFY_NEW: { url: "phone/verify/new", title: "PHONE_VERIFY_NEW" },
  };

export interface AuthResponse {
  nextStep: authSteps | null;
  sessionToken: string | null;
  refreshToken: string | null;
  accessToken: string | null;
  oneTimeAccessToken?: string | null;
  secret?: string | null;
}
